import React from "react";
import Box from "@mui/material/Box/Box";
import GenieText from "../../../../components/core/genie-text/GenieText";
import { Organization } from "../../../../types/api/User";
import { useNavigate } from "react-router-dom";
import { alpha, Chip } from "@mui/material";

interface Props {
  organization: Organization;
  isSelf: boolean;
}

function SplashMap({ organization, isSelf }: Props) {
  const navigate = useNavigate();
  return (
    <Box
      onClick={() => navigate(`/storefront/${organization.id}`)}
      mb={2}
      sx={{
        position: "relative",
      }}
    >
      <Box
        sx={{
          height: "100%",
          width: "100%",
        }}
      >
        <Box
          borderRadius={2}
          sx={{
            transition: "transform 0.2s ease-in-out",
            borderWidth: 1,
            borderColor: "transparent",
            cursor: "pointer",
            "&:hover": {
              transform: "scale(1.01)",
              borderColor: "grey.300",
            },
            width: "100%",
            height: "300px",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundImage: `url(${
              organization?.image_set?.splash_image?.cloudinary_url || ``
            })`,
          }}
        />
        <Box
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          height={"100%"}
        >
          <Box
            sx={{
              textAlign: "center",
              position: "absolute",
              top: "25%",
              pointerEvents: "none",
            }}
          >
            <img
              width={"65px"}
              height={"65px"}
              src={
                organization?.image_set?.logo?.cloudinary_url ||
                `https://via.placeholder.com/65`
              }
              alt={"Logo"}
            />
            <Box bgcolor={alpha("#ffffff", 0.5)} borderRadius={4} px={4}>
              <GenieText fontWeight={"bold"} fontSize={"large"}>
                {organization.name}{" "}
                {isSelf && (
                  <Chip
                    color={"primary"}
                    variant={"filled"}
                    label={"Your Store"}
                  ></Chip>
                )}
              </GenieText>
              <GenieText style={{ mx: 2 }}>
                {organization.slogan || ""}
              </GenieText>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default SplashMap;
